import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import propTypes from 'prop-types'
import DocumentTitle from 'react-document-title'

import Row from '@components/Details/Row'
import Actions from './Actions'
import { StatusLabel } from '@components/StatusLabel'

import ACL from '@components/ACL/ACL'
import Button from '@components/Button'
import NoContent from '@components/Error/NoContent'
import WarningIcon from '@components/Icon/Warning'
import InfoBox from '@components/InfoBox'
import RejectModal from '@components/Modals/RejectModal'

class PaymentDetails extends Component {
  constructor () {
    super()
    this.state = {
      isRejectModalVisible: false
    }
  }

  addExpertPaymentDetails = () => {
    const { paymentDetails, modalStore } = this.props
    modalStore.show({
      type: 'EXPERT_PAYMENT_DETAILS_FORM',
      props: {
        paymentData: paymentDetails
      }
    })
  }

  renderInvoiceNeeded = () => {
    if (this.props.paymentDetails.invoiceNeeded) {
      return 'Yes'
    }
    return 'No'
  }

  renderApproveButton = () => {
    const { paymentDetailsStore, paymentDetails, staticData } = this.props
    const { EXPERT_PAYMENT_DETAIL_STATUSES } = staticData.CONST

    if (
      paymentDetails.expertPaymentDetailStatusId ===
      EXPERT_PAYMENT_DETAIL_STATUSES.CONFIRMED
    ) {
      return (
        <button
          onClick={() => paymentDetailsStore.approve(paymentDetails.expertId)}
          className='button button-medium button--primary'
        >
          Approve
        </button>
      )
    }
    return null
  }

  renderRejectButton = () => {
    const { paymentDetails, staticData } = this.props
    const { EXPERT_PAYMENT_DETAIL_STATUSES } = staticData.CONST

    if (
      paymentDetails.expertPaymentDetailStatusId !==
      EXPERT_PAYMENT_DETAIL_STATUSES.UNCONFIRMED
    ) {
      return (
        <button
          onClick={this.toggleShowRejectModal}
          className='button button-medium button--secondary'
        >
          Reject
        </button>
      )
    }
    return null
  }

  renderConfirmButton = () => {
    const { paymentDetailsStore, paymentDetails, staticData } = this.props
    const { EXPERT_PAYMENT_DETAIL_STATUSES } = staticData.CONST

    if (
      paymentDetails.expertPaymentDetailStatusId ===
      EXPERT_PAYMENT_DETAIL_STATUSES.UNCONFIRMED
    ) {
      return (
        <button
          onClick={() => paymentDetailsStore.confirm(paymentDetails.expertId)}
          className='button button-medium button--primary'
        >
          Confirm
        </button>
      )
    }
    return null
  }

  toggleShowRejectModal = () => {
    this.setState({ isRejectModalVisible: !this.state.isRejectModalVisible })
  }

  renderExpertDetails = paymentDetails => {
    const { staticData } = this.props

    if (!paymentDetails.expertsAddress) {
      return null
    }

    const expertCountryId = paymentDetails.expertsAddress.countryId

    return (
      <div className='group'>
        <Row label='Address' text={paymentDetails.expertsAddress.address1} />
        <Row label='City' text={paymentDetails.expertsAddress.city} />
        <Row
          label='Postal code'
          text={paymentDetails.expertsAddress.postalCode}
        />
        <Row
          label='State/Province'
          text={paymentDetails.expertsAddress.state}
        />
        <Row
          label='Country'
          text={staticData.names.countries[expertCountryId]}
        />
      </div>
    )
  }

  renderBankAddressDetails = () => {
    const { paymentDetails, staticData } = this.props

    if (!paymentDetails.bankAddress) {
      return null
    }

    const bankCountryId =
      paymentDetails.bankAddress && paymentDetails.bankAddress.countryId

    return (
      <div>
        <Row
          label='Bank street address'
          text={paymentDetails.bankAddress.address1}
        />
        <Row label='Bank city' text={paymentDetails.bankAddress.city} />
        <Row
          label='Bank zip code'
          text={paymentDetails.bankAddress.postalCode}
        />
        <Row label='Bank state' text={paymentDetails.bankAddress.state} />
        <Row
          label='Bank country'
          text={staticData.names.countries[bankCountryId]}
        />
      </div>
    )
  }

  renderBankDetails = () => {
    const { paymentDetails, staticData } = this.props
    const { PAYMENT_TRANSFER_METHODS } = staticData.CONST

    if (
      paymentDetails.paymentTransferMethodId !==
        PAYMENT_TRANSFER_METHODS.DIRECT_TRANSFER &&
      paymentDetails.paymentTransferMethodId !==
        PAYMENT_TRANSFER_METHODS.DONATION_OTHER
    ) {
      return null
    }

    return (
      <div className='group'>
        <Row label='Account owner' text={paymentDetails.accountOwner} />
        <Row label='Account number/IBAN' text={paymentDetails.accountNumber} />
        <Row label='SWIFT CODE/ROUTING NUMBER' text={paymentDetails.bankCode} />
        <Row label='Bank name' text={paymentDetails.bankName} />
        {this.renderBankAddressDetails()}
      </div>
    )
  }

  renderPaypalDetails = () => {
    const { paymentDetails, staticData } = this.props
    const { PAYMENT_TRANSFER_METHODS } = staticData.CONST

    if (
      paymentDetails.paymentTransferMethodId !== PAYMENT_TRANSFER_METHODS.PAYPAL
    ) {
      return null
    }

    return (
      <div className='group'>
        <Row label='PayPal email' text={paymentDetails.payPalEmail} />
      </div>
    )
  }

  renderPaymentServiceGroup = paymentDetails => {
    return (
      <div className='group'>
        <Row label='Company name' text={paymentDetails.companyName} />
        <Row label='VAT number' text={paymentDetails.vatNumber} />
        <Row label='VAT class' text={`${paymentDetails.vatClass}%`} />
      </div>
    )
  }

  renderWarningMessage = () => {
    const { paymentDetails, staticData } = this.props
    const { EXPERT_PAYMENT_DETAIL_STATUSES } = staticData.CONST

    if (
      paymentDetails.expertPaymentDetailStatusId !==
      EXPERT_PAYMENT_DETAIL_STATUSES.UNCONFIRMED
    ) {
      return null
    }
    return (
      <InfoBox theme='red' icon={<WarningIcon />}>
        <span>
          Please review your details and edit them if necessary. <br />
          Once they are correct, click CONFIRM and we'll proceed with payment
          procedure
        </span>
      </InfoBox>
    )
  }

  render () {
    const { paymentDetails, staticData, paymentDetailsStore } = this.props

    if (!paymentDetails) return null

    const INCOMPLETE =
      staticData.CONST.EXPERT_PAYMENT_DETAIL_STATUSES.INCOMPLETE
    const paymentDetailsStatusId =
      paymentDetails && paymentDetails.expertPaymentDetailStatusId

    const firstName = paymentDetails.expert.firstName
    const lastName = paymentDetails.expert.lastName

    if (paymentDetailsStatusId === INCOMPLETE) {
      return (
        <NoContent label='Payment details incomplete'>
          <ACL roles={['AdvancedExpertManagement']}>
            <Button
              primary
              className='m-t-xl'
              onClick={this.addExpertPaymentDetails}
            >
              Add payment details
            </Button>
          </ACL>
        </NoContent>
      )
    }

    const paymentTypes = staticData.names.paymentServiceTypes
    const paymentTransferMethods = staticData.names.paymentTransferMethods
    const paymentTransferMethodId = paymentDetails.paymentTransferMethodId

    return (
      <DocumentTitle
        title={`${firstName} ${lastName} - payment details | Atheneum Partners`}
      >
        <div className='details-wrapper'>
          <RejectModal
            isVisible={this.state.isRejectModalVisible}
            toggleShowModal={this.toggleShowRejectModal}
            label='Please choose rejection reason'
            reasonsList={paymentDetailsStore.rejectionReasons}
            paymentDetailsStore={paymentDetailsStore}
          />

          <div className='animate-intro'>
            <div className='actions-wrapper actions-wrapper--space-between'>
              <div>
                <span className='label m-r-sm'>
                  Expert payment details status
                </span>
                <StatusLabel
                  statusId={paymentDetails.expertPaymentDetailStatusId}
                  statusesType='expertPaymentDetailStatuses'
                />
              </div>
              <Actions paymentData={paymentDetails} />
            </div>

            <div className='content'>
              {this.renderWarningMessage()}

              <div className='col-2'>
                <div className='story'>
                  <span className='label'>Payment details</span>
                  <div className='group-wrapper'>
                    <div className='group'>
                      <Row
                        label='Payment service type'
                        text={paymentTypes[paymentDetails.paymentServiceTypeId]}
                      />
                      <Row
                        label='Invoice needed'
                        text={this.renderInvoiceNeeded()}
                      />
                    </div>

                    {this.renderPaymentServiceGroup(paymentDetails)}
                    {this.renderExpertDetails(paymentDetails)}
                  </div>
                </div>
              </div>

              <div className='col-2'>
                <div className='story'>
                  <span className='label'>Payment method</span>
                  <div className='group-wrapper'>
                    <div className='group'>
                      <Row
                        label='Payment transfer method'
                        text={paymentTransferMethods[paymentTransferMethodId]}
                      />
                    </div>

                    {this.renderBankDetails()}
                    {this.renderPaypalDetails()}

                    <div className='group'>
                      <Row label='Comments' text={paymentDetails.comment} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='button-container'>
              <ACL roles={['AdvancedExpertManagement']}>
                {this.renderApproveButton()}
                {this.renderRejectButton()}
                {this.renderConfirmButton()}
              </ACL>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

PaymentDetails.propTypes = {
  paymentDetails: propTypes.object,
  staticData: propTypes.object,
  modalStore: propTypes.object,
  paymentDetailsStore: propTypes.object
}

export default inject(
  'modalStore',
  'staticData',
  'paymentDetailsStore'
)(observer(PaymentDetails))
